export default "__VITE_ASSET__9zCnNTK___"